export {default as componentType} from './componentType';
export {default as oneOfComponentType} from './oneOfComponentType';
export {default as origin} from './origin';
export {default as deprecate} from './deprecated';
export {default as style} from './style';
export {default as ZDepth} from './zDepth';



// WEBPACK FOOTER //
// ./../src/utilities/CustomPropTypes/index.js